export enum AssociateProductType {
  Akrochem = "AKROCHEM",
  Competitor = "COMPETITOR",
}

export interface AssociateProductTypeOption {
  value: AssociateProductType
  label: string
}
